import defaultActions from './defaultReduxActions';

const actions = defaultActions({ namespace: 'account-tax-programs' });

export const { find, create, get, patch, reducer, remove } = actions;

export default reducer;
